import { message, theme } from 'antd';
import { useState } from 'react';
import axios from 'axios';

const useBoardsIndex = ({ initialBoards }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [boards, setBoards] = useState(initialBoards);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingBoard, setEditingBoard] = useState(null);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const csrf = () => document.head.querySelector("[name='csrf-token']").content;

  const handleCreate = () => {
    setEditingBoard(null);
    setIsModalOpen(true);
  };

  const handleEdit = (board) => {
    setEditingBoard(board);
    setIsModalOpen(true);
  };

  const handleDelete = (board) => {
    axios({
      headers: { 'X-CSRF-Token': csrf() },
      method: 'delete',
      url: `/boards/${board.id}`,
    }).then(() => {
      setBoards((prev) => prev.filter((b) => b.id !== board.id));
      messageApi.success('Дошку успішно видалено');
    }).catch((error) => {
      const errorMessage =
        error?.response?.data?.errors?.join('; ') || 'Помилка при видаленні дошки';
      messageApi.error(errorMessage);
    });
  };

  const handleModalSubmit = (values) => {
    const isEditing = !!editingBoard;

    axios({
      headers: { 'X-CSRF-Token': csrf() },
      method: isEditing ? 'put' : 'post',
      url: isEditing ? `/boards/${editingBoard.id}` : '/boards',
      data: { board: values },
    }).then((response) => {
      if (isEditing) {
        setBoards((prev) => prev.map((b) => (b.id === editingBoard.id ? { ...b, ...values } : b)));
        messageApi.success('Дошку успішно оновлено');
      } else {
        const newBoard = response.data;
        setBoards((prev) => [...prev, newBoard]);
        messageApi.success('Дошку успішно створено');
      }
      setIsModalOpen(false);
      setEditingBoard(null);
    }).catch((error) => {
      const errorMessage =
        error?.response?.data?.errors?.join('; ') || 'Помилка при збереженні дошки';
      messageApi.error(errorMessage);
    });
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditingBoard(null);
  };

  return {
    boards,
    isModalOpen,
    editingBoard,
    colorBgContainer,
    borderRadiusLG,
    contextHolder,
    handleCreate,
    handleEdit,
    handleDelete,
    handleModalSubmit,
    handleModalClose,
  };
};

export default useBoardsIndex;
